// ***************************************
// AngryTutorial
//
// This dialog displays a tutorial.
//
// Copyright 2015 Tingly Games B.V.
// Last Changed: 23-9-2015
// ***************************************
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { tbEase } from "../../engine/tbEase";
import { ComponentButton } from "../../framework/components/ComponentButton";
import { ComponentLabel } from "../../framework/components/ComponentLabel";
import { ComponentLayoutVertical } from "../../framework/components/ComponentLayout";
import { ComponentPicture } from "../../framework/components/ComponentPicture";
import { DialogBase } from "../../framework/dialogs/DialogBase";
import { tbKeyCodes } from "../../framework/tbKeyCodes";
import { tgfDictionary } from "../../framework/tgfDictionary";
import { tgfEffects } from "../../framework/tgfEffects";
import { tgfGraphics } from "../../framework/tgfGraphics";
import { tgfSettings } from "../../framework/tgfSettings";
import { MiscSettings } from "../../settings/Settings";
import { SoundManager } from "../../settings/SoundManager";
import { angrybirds_regular_text } from "../AssetDefinitions/FontDefinitions";
import { s_tgf_frame, s_tgf_tutorial_previous, s_tgf_tutorial_next, s_tgf_tutorial_close, s_black_square, s_icon_back_small, s_icon_forward_small, s_icon_close, s_popup_top, s_popup_bottom } from "../AssetDefinitions/ImageDefinitions";
import { playController } from "../gameController";
// Directives for jslint
/*global tbEase, tbKeyCodes */
/*global tgfFunctions, tgfDialogs, tgfComponents, tgfPlayer, tgfDictionary, tgfGraphics, tgfSettings, tgfAnalytics, tgfScale, tgfEffects */
tgfSettings.dialogDefaults.tutorial = {
    backgroundImage: s_tgf_frame,
    marginLeft: 40,
    marginRight: 40,
    marginTop: 40,
    marginBottom: 40,
    titlePercentage: 20,
    imagePercentage: 30,
    messagePercentage: 30,
    buttonPercentage: 20,
    tutorial: [],
    titleFont: angrybirds_regular_text,
    messageFont: angrybirds_regular_text,
    previousButtonImage: s_tgf_tutorial_previous,
    nextButtonImage: s_tgf_tutorial_next,
    closeButtonImage: s_tgf_tutorial_close,
    showButtons: true,
    interval: 999999,
    progressOnClick: false,
    darken: true,
    appearEffect: { effect: tgfEffects.scale, duration: 0.5, startScale: 0, ease: tbEase.easeOutOvershoot, easeArgument: 1.2 },
    disappearEffect: { effect: tgfEffects.scale, duration: 0.5, endScale: 0, ease: tbEase.easeInOvershoot, easeArgument: 1.2 },
    components: [],
    // Additional properties for the components
    darkenerProperties: null,
    backgroundProperties: null,
    titleProperties: null,
    imageProperties: null,
    textProperties: null,
    timerProperties: null,
    buttonPreviousProperties: null,
    buttonNextProperties: null,
    buttonCloseProperties: null,
    onClose: null // Callback for when the dialog is closed (fully)
};
// The constructor for the dialog
/**
 * @constructor
 * @base DialogBase
 */
var AngryTutorial = /** @class */ (function (_super) {
    __extends(AngryTutorial, _super);
    function AngryTutorial(properties) {
        if (properties === void 0) { properties = {}; }
        var _this = _super.call(this) || this;
        _this.name = "Tutorial";
        // Initialize properties
        _this.setProperties(__assign(__assign(__assign({}, tgfSettings.dialogDefaults.tutorial), tgfSettings.tutorialDialogProperties), properties));
        return _this;
    }
    ;
    // ***************************************
    // Specific methods for this dialog
    // ***************************************
    // Make the dialog disappear now
    AngryTutorial.prototype.disappear = function () {
        "use strict";
        this.deactivate();
        this.hide();
        if (this.onClose) {
            this.onClose();
        }
        this.free();
        // this.container.startSubEffect(2);
    };
    ;
    // Sets the tutorial page
    AngryTutorial.prototype.setTutorialPage = function (ind) {
        "use strict";
        var tutPage;
        // Correct the index
        if (ind < 0) {
            ind = 0;
        }
        if (ind >= this.tutorial.length) {
            ind = this.tutorial.length - 1;
        }
        // Remember the page
        this.page = ind;
        // Set the page properties
        tutPage = this.tutorial[ind];
        this.title.setText(tgfDictionary.getText(tutPage.titleKey));
        this.image.changeImage(tutPage.image);
        this.message.setText(tgfDictionary.getText(tutPage.messageKey).replace(/\<.*\>/g, ""));
        // Set the buttons to the correct state
        if (this.showButtons) {
            if (ind <= 0) {
                this.previousButton.setAlpha(0);
            }
            else {
                this.previousButton.setAlpha(1);
            }
            if (ind >= this.tutorial.length - 1) {
                this.nextButton.setAlpha(0);
            }
            else {
                this.nextButton.setAlpha(1);
            }
            if (this.delayClose && !(ind >= this.tutorial.length - 1)) {
                this.closeButton.setAlpha(0);
                this.closeButton.deactivate();
            }
            else {
                this.closeButton.setAlpha(1);
                this.closeButton.activate();
            }
        }
        // Avoid an immediate timer move
        // this.timer.reset();
    };
    ;
    // ***************************************
    // Internal methods
    // ***************************************
    // Add a component to the dialog and returns it
    AngryTutorial.prototype._addComponentToDialog = function (Component, properties, moreProperties, extraProperties) {
        "use strict";
        var comp = new Component(properties);
        if (moreProperties !== undefined) {
            comp.setProperties(moreProperties);
        }
        if (extraProperties !== undefined) {
            comp.setProperties(extraProperties);
        }
        this.addComponent(comp);
        return comp;
    };
    ;
    // Add a component to the parent component and returns it
    AngryTutorial.prototype._addComponentToComponent = function (parent, Component, properties, moreProperties, extraProperties) {
        "use strict";
        var comp = new Component(properties);
        if (moreProperties !== undefined) {
            comp.setProperties(moreProperties);
        }
        if (extraProperties !== undefined) {
            comp.setProperties(extraProperties);
        }
        parent.addComponent(comp);
        return comp;
    };
    ;
    // ***************************************
    // Preparing and showing
    // ***************************************
    // Processing required when preparing the dialog for use
    AngryTutorial.prototype.doPrepare = function () {
        "use strict";
        var _this = this;
        var i, layoutVert, ww, hh;
        if (playController) {
            playController.toggleSlingshotInput(false);
        }
        // Position
        if (this.x === undefined) {
            this.x = tgfGraphics.mainCanvas.width / 2;
        }
        if (this.y === undefined) {
            this.y = tgfGraphics.mainCanvas.height / 2;
        }
        // Create the darkener
        if (this.darken || true) {
            this.transparentBlack = new ComponentButton({
                x: -100,
                y: -100,
                xScale: Math.round(tgfGraphics.areaWidth / s_black_square.width) + 200000000,
                yScale: Math.round(tgfGraphics.areaHeight / s_black_square.height) + 200000000,
                alpha: 0.7,
                image: s_black_square
            });
            this.addComponent(this.transparentBlack);
        }
        // Create the background image container
        this.container = this._addComponentToDialog(ComponentPicture, {
            image: this.backgroundImage, createFromSlices: true, sliceMarginsArray: [55, 55, 55, 55],
            width: this.width === 0 ? this.backgroundImage.width : this.width,
            height: this.height === 0 ? this.backgroundImage.height : this.height,
            x: -this.width / 2,
            y: -this.height / 2
        }, this.backgroundProperties);
        // Create the layout of the other components
        ww = this.width === 0 ? this.backgroundImage.width : this.width;
        ww -= this.marginLeft + this.marginRight;
        hh = this.height === 0 ? this.backgroundImage.height : this.height;
        hh -= this.marginTop + this.marginBottom;
        this.container.addComponent(new ComponentPicture({ image: s_popup_top, x: this.width / 2, y: 0 }));
        this.container.addComponent(new ComponentPicture({ image: s_popup_bottom, x: this.width / 2, y: this.height - 20 }));
        layoutVert = this._addComponentToComponent(this.container, ComponentLayoutVertical, {
            x: Math.round((this.marginLeft - this.marginRight) / 2 + this.width / 2),
            y: Math.round((this.marginTop - this.marginBottom) / 2 + this.height / 2),
            width: ww, height: hh,
            adaptWidth: [true, false, true, false],
            adaptHeight: [true, false, true, true],
            componentGap: 0,
            componentHeight: [
                Math.round(this.titlePercentage * hh / 100),
                Math.round(this.messagePercentage * hh / 100),
                Math.round(this.imagePercentage * hh / 100),
                Math.round(this.buttonPercentage * hh / 100)
            ]
        });
        // Create title, image, and message
        this.title = this._addComponentToComponent(layoutVert, ComponentLabel, __assign(__assign({ font: this.titleFont }, this.titleProperties), { y: (this.titlePercentage - 50) * hh / 100 }));
        this.message = this._addComponentToComponent(layoutVert, ComponentLabel, __assign({ font: this.messageFont, splitLines: true, y: this.messagePercentage * hh / 100, width: this.container.width * 0.9, styles: {
                red: {
                    fill: "#ff0000"
                }
            } }, this.messageProperties));
        this.image = this._addComponentToComponent(layoutVert, ComponentPicture, __assign({}, this.imageProperties));
        // Create the buttons part
        if (this.showButtons) {
            var xOffset = 35;
            this.previousButton = this._addComponentToComponent(this.container, ComponentButton, {
                image: this.previousButtonImage, y: this.height / 2 + 100, x: xOffset, icon: s_icon_back_small, iconPosition: "center",
                shortcutKey: tbKeyCodes.vkLeft, touchMargin: MiscSettings.closeButtonTouchMargin, reactOnDown: true,
                onClick: function () {
                    _this.setTutorialPage(_this.page - 1);
                    SoundManager.playEffect(SoundManager.UI_STATE.SELECT, SoundManager.UICollection, 0, false);
                }
            }, this.buttonPreviousProperties);
            this.nextButton = this._addComponentToComponent(this.container, ComponentButton, {
                image: this.nextButtonImage, y: this.height / 2 + 100, x: this.width + xOffset, icon: s_icon_forward_small, iconPosition: "center",
                shortcutKey: tbKeyCodes.vkRight, touchMargin: MiscSettings.closeButtonTouchMargin, reactOnDown: true,
                onClick: function () {
                    _this.setTutorialPage(_this.page + 1);
                    SoundManager.playEffect(SoundManager.UI_STATE.SELECT, SoundManager.UICollection, 0, false);
                }
            }, this.buttonNextProperties);
            this.closeButton = this._addComponentToComponent(this.container, ComponentButton, {
                image: this.closeButtonImage,
                icon: s_icon_close,
                iconPosition: "center",
                x: this.width + 5,
                y: 33,
                shortcutKey: tbKeyCodes.vkEscape,
                touchMargin: MiscSettings.closeButtonTouchMargin,
                onClick: function () {
                    if (playController) {
                        playController.toggleSlingshotInput(true);
                    }
                    _this.disappear();
                    SoundManager.playEffect(SoundManager.UI_STATE.BACK, SoundManager.UICollection, 0, false);
                }
            }, this.buttonCloseProperties);
        }
        // Create the timer
        // this.timer = this._addComponentToComponent(this.container, tgfComponents.Timer, {
        // 		enabled: true, interval: this.interval, repeat: this.tutorial.length,
        // 		onTick: function (component) {
        // 				if (self.page >= self.tutorial.length-1) {
        // 					public disappear.call(self);
        // 				} else {
        // 					public setTutorialPage.call(self, self.page+1);
        // 				}
        // 			}
        // 	}, this.timerProperties);
        // if (this.progressOnClick) {	this.timer.onTouchDown = this.timer.onTick; }
        // Add the additional components, if any
        for (i = 0; i < this.components.length; i += 1) {
            this.container.addComponent(this.components[i]);
        }
    };
    ;
    // Processing required when freeing the dialog from use
    AngryTutorial.prototype.doFree = function () {
        "use strict";
        this.removeAllComponents();
        this.container = undefined;
        this.title = undefined;
        this.image = undefined;
        this.message = undefined;
        this.previousButton = undefined;
        this.nextButton = undefined;
        this.closeButton = undefined;
    };
    ;
    // Processing required when showing the dialog
    AngryTutorial.prototype.doShow = function () {
        "use strict";
        // Set the first tutorial page
        this.setTutorialPage(0);
    };
    ;
    return AngryTutorial;
}(DialogBase));
export { AngryTutorial };
